<div class="flex-row padding-30">
    <div class="flex-1"></div>
    <div class="flex-1">
        <h1>Thank you for registering!</h1>
        <br>
        <h2>Check your email and follow the link to complete your registration.</h2>
    </div>
    <div class="flex-1"></div>
</div>